<template>
  <div>
    <!-- QFM維護 -->
    <CCard>
      <CCardBody>
        <div class="info">
          <table class="custom-table mb-4" v-if="tableInfo">
            <tr>
              <td class="info-header" colspan="4">
                {{ i18n("QFM_Vue.QFMNo") }}：
                {{ tableInfo.qfmNo }}
              </td>
            </tr>
            <tr>
              <td>{{ i18n("QFM_Vue.StartDate") }}</td>
              <td colspan="3">{{ fixDate(tableInfo.startDate) }}</td>
            </tr>
            <tr>
              <td>{{ i18n("QFM_Vue.MaterialNo") }}</td>
              <td colspan="3">{{ tableInfo.materialNo }}</td>
            </tr>
            <tr>
              <td>{{ i18n("QFM_Vue.MaterialDescription") }}</td>
              <td colspan="3">{{ tableInfo.materialComment }}</td>
            </tr>
            <tr>
              <td>{{ i18n("QFM_Vue.ProduceDate") }}</td>
              <td colspan="3">
                <date-picker
                  format="YYYY-MM-DD"
                  valueType="format"
                  v-model="tableInfo.produceDate"
                  v-if="isEdit"
                ></date-picker>
                <span v-else>{{ fixDate(tableInfo.produceDate) }}</span>
              </td>
            </tr>
            <!-- 產品Cycle Time -->
            <tr>
              <td class="info-header text-center" colspan="4">
                {{ i18n("QFM_Vue.Product") }}
              </td>
            </tr>
            <tr>
              <td style="width: 25%">{{ i18n("QFM_Vue.MaterialLeadTime") }}</td>
              <td>
                <el-input-number
                  :controls="false"
                  v-model.trim="tableInfo.materialLeadTime"
                  min="0"
                  v-if="isEdit"
                  :precision="0"
                ></el-input-number>
                <span v-else>{{ tableInfo.materialLeadTime }}</span>
              </td>
              <td style="width: 25%">
                {{ i18n("QFM_Vue.ManufactureLeadTime") }}
              </td>
              <td>
                <el-input-number
                  :controls="false"
                  v-model.trim="tableInfo.manufactureLeadTime"
                  min="0"
                  v-if="isEdit"
                  :precision="0"
                ></el-input-number>
                <span v-else>{{ tableInfo.manufactureLeadTime }}</span>
              </td>
            </tr>
            <!-- 生產良率 -->
            <tr>
              <td class="info-header text-center" colspan="4">
                {{ i18n("QFM_Vue.ProductionYield") }}
              </td>
            </tr>
            <tr>
              <td>
                {{ i18n("QFM_Vue.InPcs") }}
                <span class="hint">({{ i18n("QDFM.InputNumber") }})</span>
              </td>
              <td>
                <el-input-number
                  :controls="false"
                  v-model="tableInfo.inPcs"
                  min="0"
                  v-if="isEdit"
                  :precision="0"
                ></el-input-number>
                <span v-else>{{ tableInfo.inPcs }}</span>
              </td>
              <td>
                {{ i18n("QFM_Vue.OutPcs") }}
                <span class="hint">({{ i18n("QDFM.InputNumber") }})</span>
              </td>
              <td>
                <el-input-number
                  :controls="false"
                  v-model="tableInfo.outPcs"
                  min="0"
                  v-if="isEdit"
                  :precision="0"
                ></el-input-number>
                <span v-else>{{ tableInfo.outPcs }}</span>
              </td>
            </tr>
            <tr>
              <td>{{ i18n("QFM_Vue.Yield") }}</td>
              <td colspan="3">{{ tableInfo.yield }} %</td>
            </tr>
            <!-- 產能Max -->
            <tr>
              <td class="info-header text-center" colspan="4">
                {{ i18n("QFM_Vue.Capacity") }}
              </td>
            </tr>
            <tr>
              <td>
                {{ i18n("QFM_Vue.DailyLinePcs") }}
                <span class="hint">({{ i18n("QDFM.InputNumber") }})</span>
              </td>
              <td>
                <el-input-number
                  :controls="false"
                  v-model="tableInfo.dailyLinePcs"
                  min="0"
                  v-if="isEdit"
                  :precision="0"
                ></el-input-number>
                <span v-else>{{ tableInfo.dailyLinePcs }}</span>
              </td>
              <td>
                {{ i18n("QFM_Vue.LinePcs") }}
                <span class="hint">({{ i18n("QDFM.InputNumber") }})</span>
              </td>
              <td>
                <el-input-number
                  :controls="false"
                  v-model="tableInfo.linePcs"
                  min="0"
                  v-if="isEdit"
                  :precision="0"
                ></el-input-number>
                <span v-else>{{ tableInfo.linePcs }}</span>
              </td>
            </tr>
            <!-- 包裝 -->
            <tr>
              <td class="info-header text-center" colspan="4">
                {{ i18n("QFM_Vue.Package") }}
              </td>
            </tr>
            <tr>
              <td>
                {{ i18n("QFM_Vue.BoxWeight") }}
                <span class="hint">({{ i18n("QDFM.InputNumber") }})</span>
              </td>
              <td colspan="3">
                <el-input-number
                  :controls="false"
                  v-model.number="tableInfo.boxWeight"
                  min="0"
                  v-if="isEdit"
                  :precision="0"
                ></el-input-number>
                <span v-else>{{ tableInfo.boxWeight }}</span>
              </td>
            </tr>
            <!-- 遭遇困難點 -->
            <tr>
              <td class="info-header text-center" colspan="4">
                {{ i18n("QFM_Vue.DifficultyPoint") }}
              </td>
            </tr>
            <tr>
              <td colspan="4" style="padding: 15px 10px">
                <div class="text-end">
                  <button
                    class="btn btn-sm btn-success mb-2"
                    v-if="isEdit"
                    @click="addRowEvent"
                  >
                    {{ i18n("Buttons.AddNew") }}
                  </button>
                </div>
                <table class="table problemTable">
                  <thead>
                    <tr>
                      <th class="text-center">
                        {{ i18n("QFM_Vue.ProblemNum") }}
                      </th>
                      <th class="text-center">
                        {{ i18n("QFM_Vue.ProblemDescription") }}
                      </th>
                      <th class="text-center">
                        {{ i18n("QFM_Vue.ProblemType") }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in tableInfo.qfmDetails"
                      :key="index"
                    >
                      <td class="text-center">
                        <span>{{ index + 1 }}</span>
                      </td>
                      <td class="text-center">
                        <el-input
                          type="text"
                          maxlength="400"
                          v-model="item.problemDescription"
                          :placeholder="i18n('QFM_Vue.Illustrate')"
                          v-if="isEdit"
                        ></el-input>
                        <span v-else>{{ item.problemDescription }}</span>
                      </td>
                      <td class="text-center">
                        <el-select
                          v-model="item.problemType"
                          :placeholder="i18n('QDFM.Select')"
                          @change="calculateTotal"
                          v-if="isEdit"
                        >
                          <el-option
                            v-for="option in problemTypeList"
                            :key="option.problemTypeId"
                            :label="option.problemTypeCaption"
                            :value="option.problemTypeId"
                          >
                            {{ option.problemTypeCaption }}
                          </el-option>
                        </el-select>
                        <span v-else>{{ item.problemType }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <!-- 審查資訊 -->
            <tr>
              <td class="info-header text-center" colspan="4">
                {{ i18n("QFM_Vue.CensorshipInformation") }}
              </td>
            </tr>
            <tr>
              <td class="info-header">
                {{ i18n("QFM_Vue.RiskAssessmentScore") }}
              </td>
              <td colspan="3">{{ tableInfo.score }}</td>
            </tr>
            <tr>
              <td>{{ i18n("QFM_Vue.UnqualifyComment") }}</td>
              <td colspan="3">
                <el-input
                  maxlength="400"
                  v-model="tableInfo.unqualifyComment"
                  v-if="isEdit"
                ></el-input>
                <span v-else>{{ tableInfo.unqualifyComment }}</span>
              </td>
            </tr>
            <tr>
              <td>{{ i18n("QFM_Vue.Improvement") }}</td>
              <td colspan="3">
                <el-input
                  maxlength="400"
                  v-model="tableInfo.improvement"
                  v-if="isEdit"
                ></el-input>
                <span v-else>{{ tableInfo.improvement }}</span>
              </td>
            </tr>
            <tr>
              <td>{{ i18n("QFM_Vue.AssessmentInstructions") }}</td>
              <td colspan="3">
                <el-input
                  v-model="tableInfo.reviewInfo"
                  v-if="isQualityEdit"
                ></el-input>
                <span v-else>{{ tableInfo.reviewInfo }}</span>
              </td>
            </tr>
          </table>

          <table class="custom-table mb-4" v-if="tableInfo">
            <tr>
              <td width="150px">{{ i18n("QFM_Vue.Time") }}</td>
              <td width="100px">{{ i18n("QFM_Vue.State") }}</td>
              <td>{{ i18n("QFM_Vue.AuditDescription") }}</td>
              <td width="180px">{{ i18n("QFM_Vue.UpdateUser") }}</td>
            </tr>

            <tr v-for="log in tableInfo.qfmLogs" :key="log.id">
              <td>{{ fixDateTime(log.logDate) }}</td>
              <td>
                <span v-if="log.reviewId === 3">{{
                  i18n("QFM_Vue.Manufacturer")
                }}</span>
                <span v-if="log.reviewId === 5">{{
                  i18n("QFM_Vue.Quality")
                }}</span>
                <span v-if="log.reviewId === 7">{{
                  i18n("QFM_Vue.Reject")
                }}</span>
                <span v-if="log.reviewId === 9">{{
                  i18n("QFM_Vue.Close")
                }}</span>
              </td>
              <td>{{ log.reviewInfo }}</td>
              <td>{{ log.creator }}</td>
            </tr>
          </table>

          <div class="send-wrap" v-if="tableInfo">
            <div>
              <el-button
                size="small"
                round
                v-if="isEdit"
                @click.prevent="memberReply"
                >{{ i18n("Buttons.Submit") }}</el-button
              >
              <el-button
                size="small"
                round
                v-if="isQualityEdit"
                @click.prevent="employeeReply(9)"
                >{{ i18n("QDFM.Close") }}</el-button
              >
              <el-button
                size="small"
                round
                v-if="isQualityEdit"
                @click.prevent="employeeReply(7)"
                >{{ i18n("Buttons.Reject") }}</el-button
              >
              <el-button size="small" round @click.prevent="goBackEvent">{{
                i18n("Buttons.GoBack")
              }}</el-button>
            </div>
          </div>
        </div>
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
import { Notification } from "element-ui";
import { qualityMixin } from "@/mixin/quality";
import { mapGetters } from "vuex";

export default {
  mixins: [qualityMixin],
  data() {
    return {
      tableInfo: {
        qfmDetails: [], // 遭遇困難點
      },

      formStatus: null, // 表單類型
      isEdit: false, // 是否為廠商操作
      isQualityEdit: false, // 是否為品質人員操作

      problemTypeList: this.$t("problemTypeList"), // 問題類別 清單
    };
  },
  props: {},
  watch: {
    lang: function () {
      this.problemTypeList = this.$t("problemTypeList"); //問題類別 清單
    },
    tableInfo: {
      //  動態計算總分
      handler() {
        const vm = this;

        if (vm.isEdit) vm.calculateTotal();
      },
      deep: true,
    },
  },
  methods: {
    i18n(keyStr) {
      return this.$t(keyStr);
    },

    // 返回
    goBackEvent(){
      this.$router.push('qfm');
      sessionStorage.removeItem("QFM_Id");
    },

    // 計算 良率(%) / 產能 / 風險評估分數
    calculateTotal() {
      const vm = this;

      // 良率(%) = 產出數(pcs) ÷ 投入數(pcs) × 100％
      let yieldPercent = 0;
      yieldPercent = (vm.tableInfo.outPcs / vm.tableInfo.inPcs) * 100;

      if (isNaN(yieldPercent) || yieldPercent === Infinity) {
        yieldPercent = 0;
      }

      vm.tableInfo.yield = yieldPercent;

      // 產能 = 一條線一天 * 良率% * 線體數
      let capacity = 0;
      capacity =
        vm.tableInfo.dailyLinePcs * (vm.tableInfo.linePcs / 100) * vm.tableInfo.yield;
      
      ///////////////////////////////   風險評估分數   ///////////////////////////////
      let total = 0;

      // 產能 --> 小於3000扣40分，大於3000得40分（欄位有值得分，若為Null不計分）
      if (capacity && capacity > 3000) total += 40;

      // 包裝箱重 --> 大於20扣20分，小於20得20分（欄位有值得分，若為Null不計分）
      if (vm.tableInfo.boxWeight && vm.tableInfo.boxWeight < 20) total += 20;

      // 遭遇困難點 --> 下拉式清單值為無問題反應得40分，填報其它下拉選項皆扣40分
      let problemType = [];
      let isNoProblem = false;
      vm.tableInfo.qfmDetails.forEach((r) => {
        if (r.problemType) {
          problemType.push(r.problemType);
          if (
            problemType.indexOf("下次生產前可克服") === -1 &&
            problemType.indexOf("長期改善計畫") === -1 &&
            problemType.indexOf("需要ROE協助") === -1
          ) {
            isNoProblem = true;
          } else {
            isNoProblem = false;
          }
        }
      });
      if (isNoProblem) {
        total += 40;
      }

      // 將計算的總分回寫
      vm.tableInfo.score = total;
    },

    // 新增 遭遇困難點
    addRowEvent() {
      this.tableInfo.qfmDetails.push({
        problemDescription: "",
        problemType: null,
      });
    },

    // 取得 QFM Detail Api
    getDetail(id) {
      const vm = this;

      if (!id) return;

      const url = `${this.$baseApiUrl}/QFM/QFMMaster/${id}`;

      this.updateLoading(true);
      this.axios.get(url).then((response) => {
        // console.log("QFM Detail", response);
        const { errorMessage } = response.data;
        this.updateLoading(false);

        if (errorMessage) {
          Notification({
            title: "失敗",
            message: errorMessage,
            type: "error",
            duration: 5000,
          });

          vm.$router.push({
            path: "/qfm",
          });
        } else {
          //  --成功
          vm.tableInfo = response.data;

          if (
            vm.formStatus === "reply" &&
            response.data.reviewId === 3 &&
            response.data.qfmDetails.length < 1
          ) {
            vm.tableInfo.qfmDetails = [];
            vm.tableInfo.qfmDetails.push({
              problemDescription: "",
              problemType: null,
            });
          }
        }
      });
    },

    // 檢核 廠商送出參數，都滿足則回傳 true
    checkParam(param) {
      const chkFileds = {
        produceDate: "請選擇生產日",
        materialLeadTime: "請填寫原料Lead Time(Day)",
        manufactureLeadTime: "請填寫製程Lead Time(Day)",
        inPcs: "請填寫投入數(pcs)",
        outPcs: "請填寫產出數(pcs)",
        dailyLinePcs: "請填寫一條線一天(pcs)",
        linePcs: "請填寫線體數",
        boxWeight: "請填寫箱重(Kg)",
        improvement: "改善說明",
      };
      for (let fd in chkFileds) {
        let val = param[fd];
        if (val !== false && !val && val !== 0) {
          //無此參數資料
          this.$alert(chkFileds[fd], "警告", { type: "warning" });
          return false;
        }
      }

      // 遭遇困難點
      const chkProblemRows = this.tableInfo.qfmDetails;
      let okRowCount = 0;
      let hadError = false;
      chkProblemRows.forEach((r) => {
        if (r.problemDescription && r.problemType) {
          okRowCount += 1;
        } else {
          if (r.problemDescription && !r.problemType) {
            hadError = true;
          } else if (!r.problemDescription && r.problemType) {
            hadError = true;
          }
        }
      });
      if (hadError) {
        this.$alert("問題描述/問題描述必須同時都輸入！", "警告", {
          type: "warning",
        });
        return false;
      }
      if (okRowCount === 0) {
        this.$alert("遭遇困難點至少要有一筆資料！", "警告", {
          type: "warning",
        });
        return false;
      }

      return true;
    },

    // 廠商回覆送出 Api
    memberReply() {
      const vm = this;
      const api = `${this.$baseApiUrl}/QFM/QFMMaster`;

      let param = {
        ...vm.tableInfo,
      };

      if (!this.checkParam(param)) {
        return;
      }
      // console.log(param);

      this.updateLoading(true);

      this.axios.patch(api, param).then((response) => {
        const { errorMessage } = response.data;
        this.updateLoading(false);

        if (errorMessage) {
          Notification({
            title: "失敗",
            message: errorMessage,
            type: "error",
            duration: 5000,
          });
        } else {
          //  --成功
          Notification({
            title: "成功",
            message: "送出成功",
            type: "success",
            duration: 5000,
          });
          vm.$router.push({
            path: "/qfm",
          });
        }
      });
    },

    // 退件 / 結案 Api (瑞儀品質人員簽核)
    employeeReply(reviewId) {
      const vm = this;
      const url = `${this.$baseApiUrl}/QFM/AuditQFMMaster`;

      let param = {
        id: vm.tableInfo.id,
        reviewInfo: vm.tableInfo.reviewInfo,
        reviewId: reviewId,
      };
      // 不管是退件還是結案 都必填
      if (vm.tableInfo.reviewInfo === null || !vm.tableInfo.reviewInfo) {
        Notification({
          title: "失敗",
          message: "您需必填評核說明",
          type: "warning",
          duration: 5000,
        });

        return;
      }

      this.updateLoading(true);

      this.axios.patch(url, param).then((response) => {
        const { errorMessage } = response.data;
        this.updateLoading(false);

        if (errorMessage) {
          Notification({
            title: "失敗",
            message: errorMessage,
            type: "error",
            duration: 5000,
          });
        } else {
          //  --成功
          Notification({
            title: "成功",
            message: "送出成功",
            type: "success",
            duration: 5000,
          });
          vm.$router.push({
            path: "/qfm",
          });
        }
      });
    },
  },
  props: {
    formData: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters(["lang"]),
  },
  mounted() {
    const QFM_Id = sessionStorage.getItem("QFM_Id");
    if (QFM_Id) this.getDetail(QFM_Id);

    let arr = location.href.split("qfmid=");
    // console.log(arr);
    if (arr.length > 1) this.getDetail(arr[1]);

    console.log("roleId", this.$userInfo.roleId);
    const vm = this;
    vm.formStatus = vm.formData.formStatus;

    // 廠商 廠商回覆中 或 退件
    if (vm.formStatus === "reply") {
      this.isEdit = true;
    } else {
      this.isEdit = false;
    }

    // 品質人員 品質審核中
    if (vm.formStatus === "review") {
      this.isQualityEdit = true;
    } else {
      this.isQualityEdit = false;
    }
  },
  created() {},
};
</script>
<style lang="scss" scoped>
table th:first-child {
  // text-align: center;
  text-align: left;
  padding: 15px 5px;
}

.table tr:nth-child(even) {
  background-color: transparent;
}

.custom-table {
  width: 100%;
  margin-bottom: -1px;

  th,
  td {
    border: 2px solid #000;
    padding: 0.4rem;
  }

  // .info-header{
  //   background-color: #BDD6EE;
  // }

  .uploded-file-list {
    list-style: none;

    padding: 0;
    margin-bottom: 0;

    li {
      display: flex;
      justify-content: space-between;
      align-items: center;

      &:nth-child(odd) {
        background-color: #f5f5f5;
      }

      a,
      .link {
        color: #0e52c1;
        cursor: pointer;
      }
    }

    .delete-btn {
      background-color: transparent;
      color: #000;
      border: none;
      transition: all 0.2s;

      &:hover {
        background-color: #f56c6c;
        color: #fff;
      }
    }
  }

  ::v-deep .el-input-number .el-input__inner {
    text-align: left;
  }

  ::v-deep .el-input-number,
  ::v-deep .el-select {
    width: 100%;
  }
}

//下方按鈕
.send-wrap {
  text-align: center;
  position: sticky;
  margin-top: 20px;
  bottom: 20px;
  z-index: 5;

  & > div {
    background: linear-gradient(336deg, #70c5d2 35%, #2f75d1 100%);
    box-shadow: 3px -3px 5px rgba(0, 0, 0, 0.05);
    z-index: 3;
    border-radius: 25px;
    display: inline-block;
    padding: 8px;

    .el-button--default {
      border: 1px solid #fff;
      background-color: transparent;
      color: #fff;
    }
    .el-button--warning {
      border: 1px solid #fff;
      background-color: #fff;
      color: #000;
    }
  }
}

::v-deep .el-input__inner {
  border-width: 2px;
  border-color: #dcdfe6;
  height: 40px;
  line-height: 40px;
}

.hint {
  color: #f93154 !important;
  font-size: 12px;
}

.problemTable {
  border: 1px solid #000;
  margin-bottom: 0;
  th {
    border: 1px solid #000;
    padding: 15px 5px;
  }
  td {
    border: 1px solid #000;
  }
  span {
    font-size: 16px;
    font-weight: 400;
  }
}
</style>
